export const ENABLE_REGISTRATION = process.env.REACT_APP_ENABLE_REGISTRATION === 'true';
export const API_URL = process.env.REACT_APP_API_URL;
export const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL;
export const LOBBY_IMAGES_BASE_URL = process.env.REACT_APP_LOBBY_IMAGES_BASE_URL;
